import { IColor } from 'components/Modals/ColorModal/ColorModal';
import { getIndexesOfInputsInOutputs } from 'pages/ConfigurePage/ConfigureForm/helpers';
import { IQuestion } from 'types/Question.types';

export const getChosenColorOptionFromQuestionOptions = (
  chosenColorValue: string | string[] | undefined,
  question: IQuestion
): IColor | undefined => {
  if (!chosenColorValue) return undefined;

  const indexesOfInputsInOutputs: number[] = getIndexesOfInputsInOutputs(
    question.inputs,
    question.outputs
  );

  // Normalize to array for comparison
  const chosenValues = Array.isArray(chosenColorValue)
    ? chosenColorValue
    : [chosenColorValue];

  for (const option of question.options) {
    // Check ALL input fields match, not just the first one
    const allMatch = indexesOfInputsInOutputs.every(
      (index, i) => option[index] === chosenValues[i]
    );

    if (allMatch) {
      const formattedOption: Partial<IColor> = {};
      Object.keys(question.outputs).forEach(
        (outputKey: string, outputIndex: number) => {
          const value = option[outputIndex];
          (formattedOption as Record<string, string>)[outputKey] = value
            ? String(value)
            : '';
        }
      );
      return formattedOption as IColor;
    }
  }
  return undefined;
};
